<template>
  <div class="w-100">
    <!-- NAME -->
    <div class="w-100 mb-4" v-if="formDisplayStatus.name.show">
      <label class="body-3 mb-1 d-block">Your Name <span v-if="formDisplayStatus.name.required" class="font-weight-bold text-danger">*</span></label>
      <input 
        type="text" 
        @input="saveData('name')" 
        class="p-2-5 body-2-1 w-100 border-form radius-6" 
        :class="{'border-danger': error_form.name != ''}"
        placeholder="Jhon" 
        v-model="form.name" >
      <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.name != ''">{{ error_form.name }}</p>
    </div>

    <!-- EMAIL -->
    <div class="w-100 mb-4" v-if="formDisplayStatus.email.show">
      <label class="body-3 mb-1 d-block">{{$t('hotel.visitor-detail.email')}} <span v-if="formDisplayStatus.email.required" class="font-weight-bold text-danger">*</span></label>
      <div class="position-relative">
        <input 
        type="text" 
        @input="saveData('email')" 
        class="p-2-5 body-2-1 w-100 border-form radius-6" 
        :class="{'border-danger': error_form.email != ''}"
        placeholder="email@example.com" 
        v-model="form.email" >
        <div class="position-absolute" style="top:12px;right:16px;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="local_post_office_24px">
            <path id="icon/maps/local_post_office_24px" fill-rule="evenodd" clip-rule="evenodd" d="M22 6C22 4.90002 21.1 4 20 4H4C2.90002 4 2 4.90002 2 6V18C2 19.1 2.90002 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM12 13L4 8V18H20V8L12 13Z" fill="black" fill-opacity="0.54"/>
            </g>
          </svg>
        </div>
      </div>
      <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.email != ''">{{ error_form.email }}</p>
    </div>

    <!-- PHONE -->
    <div class="w-100 mb-4" v-if="formDisplayStatus.phone_number.show">
      <label class="body-3 mb-1 d-block">{{$t('hotel.visitor-detail.phone-number')}} <span v-if="formDisplayStatus.phone_number.required" class="font-weight-bold text-danger">*</span></label>
      <div class="position-relative w-100 border-form radius-6" :class="{'border-danger': error_form.phone_number != ''}">
        <div class="row no-gutters">
          <div class="col-5 align-self-center">
            <div class="pr-4 border-r-form" :key="form_key">
              <v-select
                class="border-none"
                :clearable="false"
                :options="data_option.country"
                @input="refreshFrom()" 
                label="label" 
                v-model="extraForm.phoneNumberCountry">
                  <template #search="{ attributes, events }">
                    <input
                      :placeholder="extraForm.phoneNumberCountry.code ? '' : '+00'"
                      class="vs__search no-focus-border"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                
                  <template #selected-option="{ dial_code }">
                    <p class="mb-0 body-2-1">{{ dial_code }}</p>
                  </template>
                  <template v-slot:option="option">
                    <div class="d-inline-block align-middle mr-2">
                      <country-flag :country='option.code' size='small'/>
                    </div>
                    <p class="mb-0 d-inline-block align-middle body-2-1">{{`${option.code} (${option.dial_code})`}}</p>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-7 align-self-center">
            <input type="text" @input="saveData('phone_number')" class="w-100 border-none no-focus-border body-2-1 pl-3" placeholder="000 000 000" v-model="form.phone_number" >
          </div>
        </div>
        <div class="position-absolute" style="top:12px;right:16px;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="phone_24px">
              <path id="icon/communication/phone_24px" fill-rule="evenodd" clip-rule="evenodd" d="M4 3H7.5C8.04999 3 8.5 3.45001 8.5 4C8.5 5.25 8.70001 6.45001 9.07001 7.57001C9.17999 7.92001 9.09998 8.31 8.82001 8.59L6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.61 14.99 15.86 14.89 16.12 14.89C16.22 14.89 16.33 14.9 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45001 3.45001 3 4 3ZM6.54004 5C6.60004 5.89001 6.75 6.76001 6.99005 7.59L5.79004 8.79001C5.38 7.59 5.12006 6.32001 5.03003 5H6.54004ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02Z" fill="black" fill-opacity="0.54"/>
            </g>
          </svg>
        </div>
      </div>
      <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.phone_number != ''">{{ error_form.phone_number }}</p>
    </div>

    <!-- TABLE NUMBER -->
    <div class="w-100 mb-4" v-if="formDisplayStatus.table_number.show">
      <label class="body-3 mb-1 d-block">Table Number <span v-if="formDisplayStatus.table_number.required" class="font-weight-bold text-danger">*</span></label>
      <input 
        :disabled="getRestaurantAuth.lock_table_number || getRestaurantDelivery.isActive" 
        :class="{
          'input-disabled': getRestaurantAuth.lock_table_number || getRestaurantDelivery.isActive,
          'border-danger': error_form.table_number != ''
        }" 
        type="text" 
        @input="saveData('table_number')" 
        class="p-2-5 body-2-1 w-100 border-form radius-6" 
        v-model="form.table_number" >
      <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.table_number != ''">{{ error_form.table_number }}</p>
    </div>

    <!-- NOTES -->
    <div class="w-100" v-if="formDisplayStatus.notes.show">
      <label class="body-3 mb-1 d-block">Notes</label>
      <textarea 
        class="p-2-5 body-2-1 w-100 border-form radius-6" 
        row="3" 
        @input="saveData('notes')"
        v-model="form.notes">
      </textarea>
    </div>
  </div>
</template>

<script>
  import {mapGetters,mapMutations} from 'vuex';
	import country from "@/data/country"
	import { parsePhoneNumber, parsePhoneNumberFromString ,ParseError  } from 'libphonenumber-js'
  import CountryFlag from 'vue-country-flag'
  import { validationMixin } from "vuelidate";
import { type } from 'jquery';
  const { required, email } = require("vuelidate/lib/validators");

  export default {
    components:{
      CountryFlag
    },
    props: {
      viewtype:{
        type: String,
        default: 'desktop'
      },
      type:{
        type: String,
        default: 'ORDER' //['ORDER','PAYMENT']
      },
      directRequired:{
        type: Array,
        defaul: () => []
      }
    },
    data() {
      return {
        data_option:{
          country: country
        },
        form:{
          name: '',
		      email: '',
          dial_code: {},
		      phone_number: '',
          notes: '',
          table_number: ''
        },
        extraForm: {
          phoneNumberCountry: {}
        },
        error_form:{
          name: '',
		      phone_number: '',
		      email: '',
          table_number: ''
        },
        form_key: 0
      }
    },
    mixins: [validationMixin],
    validations: {
      form:{
        name:{
          required
        },
        email: {
          required,
          email
        },
        phone_number:{
          required
        },
        table_number:{
          required
        }
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getRestaurantCustomerDetail',
        'getRestaurantCustomer',
        'getRestaurantAuth',
        'getRestaurantOrder',
        'getRestaurantDelivery'
      ]),
      data(){
				return this.getRestaurantCustomerDetail
			},
      is_mobile_view(){
        return this.viewtype == 'mobile'
      },
      formDisplayStatus(){
        let status = {
          name: { show: false, required: false },
          email: { show: false, required: false },
          phone_number: { show: false, required: false },
          table_number: { show: false, required: false },
          notes: { show: false, required: false }
        }

        const { order_form_phone_number, order_form_email	} = this.getMerchant
        
        const isOrderType = this.type === 'ORDER';
        if(isOrderType){
          status.name = {show: true, required: true};
          status.table_number = {show: !this.getRestaurantDelivery.isActive, required: true};
          status.notes.show = true;

          status.phone_number.show = order_form_phone_number !== 'HIDE';
          status.phone_number.required = order_form_phone_number === 'REQUIRED' || this.checkDirectRequired('phone_number');
          status.email.show = order_form_email !== 'HIDE';
          status.email.required = order_form_email === 'REQUIRED' || this.checkDirectRequired('email')
        }else{
          if(order_form_email === 'HIDE') status.email = { show: true, required: true };
          if(order_form_phone_number === 'HIDE') status.phone_number = { show: true, required: true };
        }

        return status;
      }
    },
    mounted(){
      this.fillData()
    },
    methods:{
      ...mapMutations([
        'setRestaurantCustomerDetail',
        'setRestaurantCustomer',
        'setRestaurantAuth',
        'setRestaurantOrderNotes'
      ]),
      checkDirectRequired(field){
        if(!this.$isNotEmptyV2(this.directRequired)) return false;
        const selectedDirectRequired = this.directRequired.find(key => key === field);
        return selectedDirectRequired ? true : false
      },
      fillData(){
        const { name, email, phone_number, table_number, notes } = this.formDisplayStatus
        this.form.name = name.show ? this.getRestaurantCustomer.name : ''
        this.form.email = email.show ? this.getRestaurantCustomer.email : ''
        this.form.phone_number = phone_number.show ? this.getRestaurantCustomer.phone_number : ''
        this.form.table_number = table_number.show ? this.getRestaurantAuth.table_number : ''
        this.form.notes = notes.show ? this.getRestaurantOrder.notes : ''

        if(phone_number.show){
          this.setPhoneNumberCountry();

          const { phone_number: phoneNumberValue } = this.getRestaurantCustomer
          const isPhoneNumberEmpty = phoneNumberValue == '#' || phoneNumberValue == '' || phoneNumberValue == undefined || phoneNumberValue == null
          if(!isPhoneNumberEmpty) this.checkPhoneNumber(phoneNumberValue)
        }
      },
      setPhoneNumberCountry(){
        this.data_option.country = this.data_option.country.map(x=>{
          x.label = `${x.code}/${x.dial_code}`
          return x
        })
        this.extraForm.phoneNumberCountry = {}
      },  
      checkPhoneNumber(phone_number){
        try{
          const phone_parsed = parsePhoneNumberFromString(phone_number)
          if (phone_parsed) {
            this.extraForm.phoneNumberCountry = this.data_option.country.find(x => x.code == phone_parsed.country)
            this.form.phone_number = phone_parsed.nationalNumber
          }else{
            for(let i = 0; i < this.data_option.country.length; i++){
              let el = this.data_option.country[i]
              let check_country = parsePhoneNumber(phone_number,el.code)
              if(check_country.isValid()){
                this.extraForm.phoneNumberCountry = this.data_option.country.find(x => x.code == check_country.country)
                this.form.phone_number = check_country.nationalNumber
                break;
              }
              if(i+1 == this.data_option.country.length && !check_country.isValid()){
                console.log("Invalid phone number")
                this.setRestaurantCustomer([
                  {key: 'phone_number', value: ''}
                ])
                this.form.phone_number = ''
              }
            }
          }
        }catch(err){
          console.log("PHONE NUMBER ERROR :", err.message)
          this.setRestaurantCustomer([
            {key: 'phone_number', value: ''}
          ])
          this.form.phone_number = ''
        }
      },
      refreshFrom(){
        this.form_key++
        this.saveData('dial_code')
      },
      saveData(field){
        let copy_form = this.$deepCopy(this.form)
        let new_value = copy_form[field]  
        let params = []
        if(field == 'table_number'){
          params = [
            {key: field, value: new_value}
          ]
          this.setRestaurantAuth(params)
        }else if(field == 'notes'){
          this.setRestaurantOrderNotes(new_value)
        }else{
          if(field == 'dial_code') {
            new_value =  `${this.extraForm.phoneNumberCountry.dial_code}${copy_form.phone_number}`
          }
          if(field == 'phone_number') new_value = `${this.extraForm.phoneNumberCountry.dial_code}${copy_form[field]}`
          
          params = [
            {key: field == 'dial_code' ? 'phone_number' : field, value: new_value}
          ]
          this.setRestaurantCustomer(params)
        }
      },
      resetErrorMessage(){
        this.error_form = {
          name: '',
		      phone_number: '',
		      email: '',
          table_number: ''
        }
      },
      validateForm(){
        return new Promise((success,fail)=>{
          this.resetErrorMessage()
          let form_val = this.$v.form
          const { name, email, phone_number, table_number, notes } = this.formDisplayStatus
          if(name.required) this.error_form.name = form_val.name.$invalid ? 'Please input your name' : ''
          if(email.required) this.error_form.email = form_val.email.$invalid ? this.$t('hotel.visitor-detail.email-warning') : ''

          if(phone_number.required){
            let fullPhoneNumber = `${this.extraForm.phoneNumberCountry.dial_code}${this.form.phone_number}`
            if(!this.extraForm.phoneNumberCountry.code){
              this.error_form.phone_number = this.$t('hotel.visitor-detail.country-code-warning')
            }else if(form_val.phone_number.$invalid){
              this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-warning')
            }else if(fullPhoneNumber.length < 10){
              this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-invalid')
            }
          }

          if(table_number.required){
            const isTableNumberInvalid = !this.getRestaurantDelivery.isActive && form_val.table_number.$invalid
            this.error_form.table_number = isTableNumberInvalid ? 'Please input table number' : ''
          }


          const isAllFormValid = Object.entries(this.error_form).every(([key,value]) => value === '');
          if(isAllFormValid) success();
          else fail(this.type);
        })
      }
    }
  }
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number]{
    -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/restaurant-v2/GuestFormV2.vue